import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { goToCheckout } from '../lib/constants';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg' | 'xl';
  variant?: 'solid' | 'gold';
  fullWidth?: boolean;
  pulse?: boolean;
  className?: string;
  showArrow?: boolean;
}
const sizeMap = {
  md: 'px-7 py-3.5 text-base',
  lg: 'px-9 py-4.5 text-lg',
  xl: 'px-10 py-5 text-xl sm:text-2xl'
};
export function CtaButton({
  children,
  size = 'lg',
  variant = 'solid',
  fullWidth = false,
  pulse = false,
  className = '',
  showArrow = true
}: CtaButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-3 rounded-4xl font-bold tracking-tight transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-lila/50';
  const variants = {
    solid: 'bg-brand-purple text-white shadow-[0_18px_40px_-12px_rgba(91,63,214,0.6)] hover:bg-[#4b32bd]',
    gold: 'bg-brand-gold text-[#3a2a05] shadow-[0_18px_40px_-12px_rgba(217,178,90,0.6)] hover:brightness-105'
  };
  return <button type="button" onClick={goToCheckout} className={`${base} ${sizeMap[size]} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${pulse ? 'cta-pulse' : ''} ${className}`} data-id="element-224">
      <span data-id="element-225">{children}</span>
      {showArrow && <ArrowRightIcon className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-226" />}
    </button>;
}